import { findAppVersion } from '@/pages/ISWAN_BASE/AppVersion/service';
import { useRequest } from 'ahooks';
import { useCallback } from 'react';

export interface AppListItem {
  appId: string;
  appName: string;
}

export default () => {
  const { data: res, run } = useRequest(() => findAppVersion({ size: 5000 }));

  const getAppList = useCallback(() => {
    if (res === undefined) {
      return [];
    }
    const appList: AppListItem[] = [];
    res.content.forEach((item: { appId: string; appName: string }) => {
      if (!appList.some((e) => e.appId === item.appId)) {
        appList.push({
          appId: item.appId,
          appName: item.appName,
        });
      }
    });
    return appList;
  }, [res]);

  return { appList: getAppList(), refresh: run };
};
